export const HANDLE_ERRORS = 'handleErrors'
export const HANDLE_VALIDATION_ERRORS = 'handleValidationErrors'
export const SET_VALIDATION_ERRORS = 'setValidationErrors'
export const DESTROY_VALIDATION_ERRORS = 'destroyValidationErrors'
export const BANNED_ACCOUNT = 'bannedAccount'
export const SET_ERROR_STATUS_CODE = 'setErrorStatusCode'
